import { Col, Modal, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import { useRef, useState } from "react";
// import downloadImg from '../../assets/images/Dashboard/downloadImg.svg'

const ViewStorageTypeMasterModal = (props) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);
    const getSingleStorageTypeMasterData = props.getSingleStorageTypeMasterData;

    // Handle file selection
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            console.log('Selected file:', file);
        }
    };

    // Trigger file input click when attachment button is clicked
    const handleAttachmentClick = () => {
        fileInputRef.current.click();
    };

    const renderTextWithTooltip = (text) => {
        // Check if the text length exceeds 24 characters
        if (text && text.length > 24) {
            return (
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{text}</Tooltip>}
                >
                    <span>{text.substring(0, 50)}...</span>
                </OverlayTrigger>
            );
        }
        return <span>{text}</span>;
    };

    return (
        <>
            <Modal show={props.showViewDetails} onHide={props.handleCloseViewModal} className='add-customer-modal add-user-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>View Storage Type Master</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Code</label>
                                        <span>{getSingleStorageTypeMasterData[0]?.StorageTypeCode}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={8}>
                                    <div className="view-sla-data">
                                        <label>Description</label>
                                        <span>{renderTextWithTooltip(getSingleStorageTypeMasterData[0]?.StorageTypeDescription)}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Status</label>
                                        <span>{getSingleStorageTypeMasterData[0]?.Status}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Modal.Body >
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseViewModal} />
                    <SBSaveUpdateBtn btnName="Ok" onClickEffect={props.handleCloseViewModal} />
                </Modal.Footer>
            </Modal >
        </>
    );
}

export default ViewStorageTypeMasterModal;